// extracted by mini-css-extract-plugin
export default {"link":"HeaderLink_link__Kuqa8","intro-gradient":"HeaderLink_intro-gradient__sztRs"};